import CompaniesImportRequest from '../ws/CompaniesImportRequest';
import CompaniesRequest from '../ws/CompaniesRequest';
import Alert from 'react-s-alert';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsCompany } from '../../shared/model/company/PsCompany';

// CONSTANTS
export const IMPORT_OUTSOURCES_UPDATE = 'import-outsources-update';
export const IMPORT_OUTSOURCES_LOADING = 'import-outsources-loading';
export const IMPORT_OUTSOURCES_ERROR = 'import-outsources-error';
export const IMPORT_OUTSOURCE_UPDATE = 'import-outsource-update';

export const SEARCH_OUTSOURCE_UPDATE = 'search-outsource-update';
export const SEARCH_OUTSOURCE_LOADING = 'search-outsource-loading';
export const SEARCH_OUTSOURCE_ERROR = 'search-outsource-error';

// ACTIONS

export const getOutsources = (page = 1, search = '') => (dispatch) => {

    new CompaniesImportRequest(page, search)
        .onPreExecution(() => {
            dispatch({ type: IMPORT_OUTSOURCES_LOADING, payload: true });
        })
        .onSuccess(data => {
            // Enviamos los datos a redux
            dispatch({
                type: IMPORT_OUTSOURCES_UPDATE,
                payload: data,
            });
        })
        .onFail(error => {
            dispatch({ type: IMPORT_OUTSOURCES_ERROR, payload: error });
        })
        .onPostExecution(() => {
            dispatch({ type: IMPORT_OUTSOURCES_LOADING, payload: false });
        })
        .execute();
};

export const searchOutsource = (nif = '') => (dispatch) => {
    const errorFn = (error) => {
        dispatch({ type: SEARCH_OUTSOURCE_ERROR, payload: error });
        dispatch({ type: SEARCH_OUTSOURCE_LOADING, payload: false });
    };

    new CompaniesRequest(nif, false)
        .onPreExecution(() => dispatch({ type: SEARCH_OUTSOURCE_LOADING, payload: true }))
        .onSuccess((res) => {
            const isSubcontracted = !!res.data[0];
            if (isSubcontracted) {
                Alert.error(I18nUtils.tr('TR_LA_EMPRESA_ESTA_SUBCONTRATADA'));
            } else {
                new CompaniesRequest(nif)
                    .onSuccess((res) => {
                        let outsource = res.data[0];

                        if ( !outsource ) {
                            new CompaniesImportRequest(1, nif)
                                .onSuccess((importRes) => {
                                    outsource = importRes.data[0];
                                    const company = outsource ? PsCompany.fromAPIImportation(outsource) : null;
                                    dispatch({ type: SEARCH_OUTSOURCE_UPDATE, payload: company });
                                    dispatch({ type: SEARCH_OUTSOURCE_LOADING, payload: false });
                                })
                                .onFail(errorFn)
                                .execute();
                        } else {
                            if ( res.data[0].disabled ) {
                                Alert.error(I18nUtils.tr('TR_LA_SUBCONTRATA_ESTA_INACTIVA'));
                            } else {
                                dispatch({
                                    type: SEARCH_OUTSOURCE_UPDATE,
                                    payload: PsCompany.fromAPICompany(outsource)
                                });
                            }
                        }
                    })
                    .onFail(errorFn)
                    .execute();
            }
        })
        .onFail((error) => {
            dispatch({ type: SEARCH_OUTSOURCE_ERROR, payload: error });
            dispatch({ type: SEARCH_OUTSOURCE_LOADING, payload: false });
        })
        .execute();
};

export const clearSearchOutsource = () => (dispatch) => {
    dispatch({ type: SEARCH_OUTSOURCE_UPDATE, payload: null });
};

export const importOutsource = (outsource) => (dispatch) => {
    dispatch({ type: IMPORT_OUTSOURCE_UPDATE, payload: outsource });
};



// WEBPACK FOOTER //
// ./src/app/outsource/actions/importOutsourceActions.js